import { render, staticRenderFns } from "./EnterButton.vue?vue&type=template&id=31798b44&"
import script from "./EnterButton.vue?vue&type=script&lang=ts&"
export * from "./EnterButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports